import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom'
import { MainPage, CoffeePage, ForYourPleasurePage, ContactUsPage, ItemPage } from '../../pages';
import ErrorPage from '../../pages/ErrorPage';
import ThankYouPage from '../../pages/ThankYouPage';

const routes = [
  {
    path: '/',
    exact: true,
    component: MainPage,
  },
  {
    path: "/our-coffee",
    exact: true,
    render: ({ match: { url } }) => {
      return <CoffeePage url={url} />
    }
  },
  {
    path: "/our-coffee/:id",
    render: ({ match: { params: { id } } }) => {
      return <ItemPage itemId={id} />
    }
  },
  {
    path: "/for-your-pleasure",
    render: ({ match: { url } }) => {
      return <ForYourPleasurePage url={url} />
    }
  },
  {
    path: "/contact-us",
    render: ({ match: { url } }) => {
      return <ContactUsPage url={url} />
    }
  },
  {
    path: "/thank-you",
    render: ({ match: { url } }) => {
      return <ThankYouPage url={url} />
    }
  },
  {
    path: "/error-page",
    component: ErrorPage,
  },
  {
    path: '/item-page',
    component: ItemPage,
  },
];

const App = () => (
  <div className="App">
    <Switch>
      {routes.map(({ path, component = null, render = null, exact = false }) => {
        return <Route exact={exact} path={path} component={component} render={render} key={path} />
      })}
      <Redirect to="/" />
    </Switch>
  </div>
)

export default App